const IDEAL_WIDTH = 1080;
const IDEAL_HEIGHT = 608;

export const IDEAL_ASPECT_RATIO = IDEAL_HEIGHT / IDEAL_WIDTH;
export const IDEAL_ASPECT_RATIO_PERCENTAGE = 100 * IDEAL_ASPECT_RATIO;
